import type { ReactElement } from "react";
import { Route } from "react-router";
import * as ROUTES from "../constants/routes";
import { CategoryPage, OrderRedirect } from "../pages";
import { CheckoutV2AddOnPage } from "../pages/stockList/checkoutV2/CheckoutV2AddOnPage";
import { CheckoutV2CreateOrderPage } from "../pages/stockList/checkoutV2/CheckoutV2CreateOrderPage";
import { CheckoutV2EditOrderPage } from "../pages/stockList/checkoutV2/CheckoutV2EditOrderPage";
import { CheckoutV2Redirect } from "../pages/stockList/checkoutV2/CheckoutV2Redirect";
import { CheckoutV2SuccessPageWithFeed } from "../pages/stockList/checkoutV2/CheckoutV2SuccessPageWithFeed";
import { StockListPage } from "~/pages";

/** Supplier storefront browsing and its associated order checkout routes. */
export const renderStorefrontRoutes = (): ReactElement => (
  <>
    <Route path={ROUTES.SUPPLIER.pattern} element={<StockListPage />}>
      <Route index={true} element={<OrderRedirect />} />
      <Route path={ROUTES.ORDER_BUYER.pattern} element={<CategoryPage />} />
      <Route path={ROUTES.CATEGORY_BUYER.pattern} element={<CategoryPage />} />
      <Route
        path={ROUTES.CHECKOUT_BUYER.pattern}
        element={<CheckoutV2CreateOrderPage />}
      />
      <Route
        path={ROUTES.CHECKOUT_EDIT_ORDER_BUYER.pattern}
        element={<CheckoutV2EditOrderPage />}
      />
      <Route
        path={ROUTES.CHECKOUT_BUYER_ADD_ON.pattern}
        element={<CheckoutV2AddOnPage />}
      />
      <Route
        path={ROUTES.CHECKOUT_DELIVERY_BUYER.pattern}
        element={<CheckoutV2Redirect />}
      />
      <Route
        path={ROUTES.CHECKOUT_REVIEW_BUYER.pattern}
        element={<CheckoutV2Redirect />}
      />
      <Route
        path={ROUTES.CHECKOUT_CONFIRM_BUYER.pattern}
        element={<CheckoutV2Redirect />}
      />
    </Route>

    {/* Kept outside StockListPage because its provider changes success-page behavior. */}
    <Route
      path={ROUTES.ORDER_SUCCESS_BUYER.pattern}
      element={<CheckoutV2SuccessPageWithFeed />}
    />
  </>
);
